function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import { z } from 'zod';
import { Combobox, Select, Flex, Divider, MultiCombobox, Box, Button, RadioGroup, Text, useId } from '@applyboard/crystal-ui';
import { useDebouncedState } from '@applyboard/ui-utils';
import { DeleteOutlineIcon, PlusOutlineIcon } from '@applyboard/ui-icons';
import { sortBy } from 'lodash';
import { isMatching, match, P } from 'ts-pattern';
import { assert } from "../../utils/assert";
import { getEnumOptions } from "../../utils/enums";
import { JsonSchemaProperty } from "../../types";
import { useEntities, usePrefetchEntities } from "./data";
import { JsonLogic, JsonLogicArrayOperations, JsonLogicArrayFilterOperations, JsonLogicEnumOperations, JsonLogicFilter, JsonLogicSimpleOperations } from "./JsonLogicInput.types";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * The data for Yes/No nodes, wait nodes, etc. need to be a jsonlogic-compliant
 * object.
 * @see: https://jsonlogic.com/
 *
 * This component returns data in this structure when passed to the `as` prop of
 * a crystal-ui `Field` component
 */
export function JsonLogicInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    invalid = _ref.invalid,
    acceptedObjects = _ref.acceptedObjects,
    helpText = _ref.helpText,
    layout = _ref.layout;
  var _getJsonLogicValues = getJsonLogicValues({
      acceptedObjects: acceptedObjects,
      value: value
    }),
    objectName = _getJsonLogicValues.objectName,
    objectSchema = _getJsonLogicValues.objectSchema;
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(Select, {
      value: objectName || '',
      label: "Object",
      required: true,
      onChange: function onChange(newObjectName) {
        var newObjectSchema = acceptedObjects[newObjectName];
        if ((newObjectSchema === null || newObjectSchema === void 0 ? void 0 : newObjectSchema.type) === 'array') {
          _onChange({
            some: [{
              "var": newObjectName
            }, {
              '==': [{
                "var": ''
              }, '']
            }]
          });
        } else {
          _onChange({
            "in": [{
              "var": newObjectName
            }, []]
          });
        }
      },
      appearance: "styled",
      invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[object]')),
      helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[object]') ? helpText.replace('[object]', '') : '',
      children: Object.keys(acceptedObjects).map(function (key) {
        return _jsx(Select.Option, {
          value: key,
          label: acceptedObjects[key].title
        }, key);
      })
    }), match(objectSchema)["with"](P.nullish, function () {
      return null;
    })["with"]({
      type: 'object'
    }, function () {
      return _jsx(JsonLogicAttributeInput, {
        acceptedObjects: acceptedObjects,
        helpText: helpText,
        invalid: invalid,
        onChange: _onChange,
        layout: layout,
        value: value
      });
    })["with"]({
      type: 'array'
    }, function () {
      return _jsx(JsonLogicArrayInput, {
        acceptedObjects: acceptedObjects,
        helpText: helpText,
        invalid: invalid,
        onChange: _onChange,
        layout: layout,
        value: JsonLogicArrayOperations.parse(value)
      });
    }).exhaustive()]
  });
}
function JsonLogicAttributeInput(_ref2) {
  var acceptedObjects = _ref2.acceptedObjects,
    helpText = _ref2.helpText,
    invalid = _ref2.invalid,
    jsonLogicValues = _ref2.jsonLogicValues,
    _onChange2 = _ref2.onChange,
    layout = _ref2.layout,
    value = _ref2.value;
  var _ref3 = jsonLogicValues || getJsonLogicValues({
      acceptedObjects: acceptedObjects,
      value: value
    }),
    objectName = _ref3.objectName,
    objectSchema = _ref3.objectSchema,
    attributeName = _ref3.attributeName,
    attributeSchema = _ref3.attributeSchema;
  var properties = objectSchema && 'properties' in objectSchema ? objectSchema.properties : objectSchema && 'items' in objectSchema ? objectSchema.items.properties : undefined;
  if (!properties) {
    return null;
  }
  return _jsxs(Flex, {
    gap: 2,
    direction: "column",
    children: [_jsx(Select, {
      value: attributeName || '',
      label: "Attribute",
      required: true,
      onChange: function onChange(newAttributeName) {
        var newAttributeSchema = properties[newAttributeName];
        var varValue = objectSchema && 'items' in objectSchema ? newAttributeName : "".concat(objectName, ".").concat(newAttributeName);
        _onChange2(match(newAttributeSchema)["with"](P.nullish, function () {
          return {
            "in": [{
              "var": objectName
            }, []]
          };
        })["with"]({
          type: 'boolean'
        }, function () {
          return {
            '==': [{
              "var": varValue
            }, true]
          };
        })["with"]({
          type: 'string',
          "enum": P.array()
        }, function () {
          return {
            "in": [{
              "var": varValue
            }, []]
          };
        })["with"]({
          type: 'string',
          format: P.union('date', 'date-time')
        }, function () {
          return {
            '>': [{
              "var": varValue
            }, {
              "var": ''
            }]
          };
        })["with"]({
          type: P.union('number', 'integer'),
          'x-type': P.union('program-id', 'school-group-id')
        }, function () {
          return {
            "in": [{
              "var": varValue
            }, []]
          };
        })["with"]({
          type: 'array',
          items: {
            type: 'string'
          }
        }, function () {
          return {
            "in": ['', {
              "var": varValue
            }]
          };
        }).exhaustive());
      },
      appearance: "styled",
      invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[attribute]')),
      helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[attribute]') ? helpText.replace('[attribute]', '') : '',
      children: Object.keys(properties).map(function (key) {
        return _jsx(Select.Option, {
          label: properties[key].title,
          value: key
        }, key);
      })
    }), attributeSchema && _jsxs(Flex, {
      gap: 4,
      pl: 2,
      children: [_jsx(Divider, {
        direction: "vertical"
      }), _jsx(Flex.Item, {
        basis: "100%",
        children: _jsx(OperatorAndRightOperandInput, {
          acceptedObjects: acceptedObjects,
          onChange: _onChange2,
          value: value,
          helpText: helpText,
          invalid: invalid,
          layout: layout,
          jsonLogicValues: {
            objectName: objectName,
            objectSchema: objectSchema,
            attributeName: attributeName,
            attributeSchema: attributeSchema
          }
        })
      })]
    })]
  });
}
var CheckType = /*#__PURE__*/function (CheckType) {
  CheckType["Some"] = "some";
  CheckType["All"] = "all";
  CheckType["SomeWithFilter"] = "some.filter";
  CheckType["AllWithFilter"] = "all.filter";
  return CheckType;
}(CheckType || {});
var CheckValue = z["enum"]([CheckType.Some, CheckType.All, CheckType.SomeWithFilter, CheckType.AllWithFilter, '']);

/**
 * This input allows the user to build JSONLogic expressions for
 * `type: 'array'` accepted objects
 */
function JsonLogicArrayInput(_ref4) {
  var acceptedObjects = _ref4.acceptedObjects,
    helpText = _ref4.helpText,
    invalid = _ref4.invalid,
    layout = _ref4.layout,
    _onChange3 = _ref4.onChange,
    value = _ref4.value;
  var _getJsonLogicArrayVal = getJsonLogicArrayValues({
      acceptedObjects: acceptedObjects,
      value: value
    }),
    arrayName = _getJsonLogicArrayVal.arrayName,
    arraySchema = _getJsonLogicArrayVal.arraySchema,
    evaluationObjectName = _getJsonLogicArrayVal.evaluationObjectName,
    evaluationObjectSchema = _getJsonLogicArrayVal.evaluationObjectSchema,
    evaluationValue = _getJsonLogicArrayVal.evaluationValue;
  var checkValue = getCheckSelectValue(value);
  assert(checkValue, 'Invalid JsonLogic value for array type');
  var arrayWithFilter = JsonLogicArrayFilterOperations.safeParse(value);
  return _jsxs(Flex, {
    gap: 4,
    direction: "column",
    children: [_jsxs(Select, {
      label: "Check",
      value: checkValue,
      appearance: "styled",
      required: true,
      onChange: function onChange(newCheckValue) {
        var newValue = match(CheckValue.parse(newCheckValue))["with"]('', CheckType.Some, function () {
          return {
            some: [{
              "var": arrayName
            }, {
              "in": [{
                "var": ''
              }, []]
            }]
          };
        })["with"](CheckType.SomeWithFilter, function () {
          return {
            some: [{
              filter: [{
                "var": arrayName
              }, {
                and: [{
                  "in": [{
                    "var": ''
                  }, []]
                }]
              }]
            }, {
              '==': [{
                "var": ''
              }, '']
            }]
          };
        })["with"](CheckType.All, function () {
          return {
            none: [{
              "var": arrayName
            }, {
              '!': [{
                '==': [{
                  "var": ''
                }, '']
              }]
            }]
          };
        })["with"](CheckType.AllWithFilter, function () {
          return {
            none: [{
              filter: [{
                "var": arrayName
              }, {
                and: [{
                  "in": [{
                    "var": ''
                  }, []]
                }]
              }]
            }, {
              '!': [{
                '==': [{
                  "var": ''
                }, '']
              }]
            }]
          };
        }).exhaustive();
        _onChange3(newValue);
      },
      children: [_jsx(Select.Option, {
        value: CheckType.Some,
        label: "Any"
      }), _jsx(Select.Option, {
        value: CheckType.All,
        label: "All"
      }), _jsx(Select.Option, {
        value: CheckType.SomeWithFilter,
        label: "Any matching criteria"
      }), _jsx(Select.Option, {
        value: CheckType.AllWithFilter,
        label: "All matching criteria"
      })]
    }), arrayWithFilter.success && _jsx(JsonLogicFilterInput, {
      acceptedObjects: acceptedObjects,
      onChange: _onChange3,
      value: arrayWithFilter.data,
      layout: layout
    }), _jsx(JsonLogicAttributeInput, {
      acceptedObjects: acceptedObjects,
      helpText: helpText,
      invalid: invalid,
      value: evaluationValue,
      jsonLogicValues: {
        objectName: arrayName,
        objectSchema: arraySchema,
        attributeName: evaluationObjectName,
        attributeSchema: evaluationObjectSchema ? JsonSchemaProperty.parse(evaluationObjectSchema) : undefined
      },
      onChange: function onChange(newValue) {
        _onChange3(match(value)["with"]({
          some: P.array()
        }, function (matched) {
          return {
            some: [matched.some[0], newValue]
          };
        })["with"]({
          none: P.array()
        }, function (matched) {
          return {
            none: [matched.none[0], {
              '!': [newValue]
            }]
          };
        }).exhaustive());
      },
      layout: layout
    })]
  });
}
function getCheckSelectValue(value) {
  if ('none' in value) {
    return 'filter' in value.none[0] ? CheckType.AllWithFilter : CheckType.All;
  }
  if ('some' in value) {
    return 'filter' in value.some[0] ? CheckType.SomeWithFilter : CheckType.Some;
  }
}
function JsonLogicFilterInput(_ref5) {
  var acceptedObjects = _ref5.acceptedObjects,
    helpText = _ref5.helpText,
    layout = _ref5.layout,
    _onChange4 = _ref5.onChange,
    value = _ref5.value;
  var groupIdBase = useId();
  var parsedFilter = 'some' in value ? JsonLogicFilter.parse(value.some[0]) : JsonLogicFilter.parse(value.none[0]);
  var criteria = parsedFilter.filter[1].and;
  var filterObjectName = parsedFilter.filter[0]["var"];
  var filterObject = acceptedObjects[filterObjectName];
  assert(filterObject.type === 'array');
  return _jsxs(Flex, {
    direction: "column",
    children: [criteria.map(function (criterion, index) {
      var displayNumber = index + 1;
      var groupId = "".concat(groupIdBase, "-").concat(displayNumber);
      var criterionAttributeName = match(criterion)["with"]({
        '==': P._
      }, function (c) {
        return c['=='][0]["var"];
      })["with"]({
        '!=': P._
      }, function (c) {
        return c['!='][0]["var"];
      })["with"]({
        '>': P._
      }, function (c) {
        return c['>'][0]["var"];
      })["with"]({
        '>=': P._
      }, function (c) {
        return c['>='][0]["var"];
      })["with"]({
        '<': P._
      }, function (c) {
        return c['<'][0]["var"];
      })["with"]({
        '<=': P._
      }, function (c) {
        return c['<='][0]["var"];
      })["with"]({
        '!': P._
      }, function (c) {
        return c['!']["var"];
      })["with"]({
        "in": [{
          "var": P.string
        }, P.array(P._)]
      }, function (c) {
        return c["in"][0]["var"];
      })["with"]({
        "in": [P.string, {
          "var": P.string
        }]
      }, function (c) {
        return c["in"][1]["var"];
      }).exhaustive();
      var criterionAttributeSchema = filterObject.items.properties[criterionAttributeName];
      return _jsxs(Flex, {
        gap: 4,
        role: "group",
        "aria-labelledby": groupId,
        children: [_jsx(Divider, {
          direction: "vertical"
        }), _jsxs(Flex, {
          direction: "column",
          gap: 1,
          basis: "100%",
          pb: 3,
          children: [_jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [_jsx(Text, {
              variant: "labelM",
              contrast: "mid",
              id: groupId,
              children: _jsx("span", {
                style: {
                  textTransform: 'uppercase',
                  fontWeight: 700
                },
                children: "Criteria #".concat(displayNumber)
              })
            }), criteria.length > 0 && index !== 0 && _jsx(Button, {
              leadIcon: DeleteOutlineIcon,
              emphasis: "transparent",
              intent: "negative",
              size: "sm",
              "aria-label": "Delete criteria #".concat(displayNumber),
              onClick: function onClick() {
                var newCriteria = _toConsumableArray(criteria);
                newCriteria.splice(index, 1);
                var newValue = updateJsonLogicFilterValue({
                  value: value,
                  newCriteria: newCriteria
                });
                _onChange4(newValue);
              }
            })]
          }), _jsx(JsonLogicAttributeInput, {
            acceptedObjects: acceptedObjects,
            helpText: helpText,
            layout: layout,
            value: criterion,
            jsonLogicValues: {
              objectName: filterObjectName,
              objectSchema: filterObject,
              attributeName: criterionAttributeName,
              attributeSchema: criterionAttributeSchema ? JsonSchemaProperty.parse(criterionAttributeSchema) : undefined
            },
            onChange: function onChange(newValue) {
              var parsedCriterion = JsonLogicSimpleOperations.parse(newValue);
              var newCriteria = _toConsumableArray(criteria);
              newCriteria[index] = parsedCriterion;
              var updatedValue = updateJsonLogicFilterValue({
                newCriteria: newCriteria,
                value: value
              });
              _onChange4(updatedValue);
            }
          })]
        })]
      }, index);
    }), _jsxs(Flex, {
      gap: 4,
      children: [_jsx(Divider, {
        direction: "vertical"
      }), _jsx(Flex.Item, {
        grow: 1,
        children: _jsx(Button, {
          mt: 3,
          leadIcon: PlusOutlineIcon,
          intent: "primary",
          emphasis: "outlined",
          onClick: function onClick() {
            var newValue = updateJsonLogicFilterValue({
              newCriteria: [].concat(_toConsumableArray(parsedFilter.filter[1].and), [{
                '==': [{
                  "var": ''
                }, '']
              }]),
              value: value
            });
            _onChange4(newValue);
          },
          children: "Add criteria"
        })
      })]
    })]
  });
}
function updateJsonLogicFilterValue(_ref6) {
  var newCriteria = _ref6.newCriteria,
    value = _ref6.value;
  var parsedFilter = 'some' in value ? value.some[0] : value.none[0];
  return 'some' in value ? {
    some: [{
      filter: [parsedFilter.filter[0], {
        and: newCriteria
      }]
    }, value.some[1]]
  } : {
    none: [{
      filter: [parsedFilter.filter[0], {
        and: newCriteria
      }]
    }, value.none[1]]
  };
}

/**
 * This input allows the user to build the right-hand-side of the jsonlogic
 * expression
 */
function OperatorAndRightOperandInput(_ref7) {
  var value = _ref7.value,
    _onChange5 = _ref7.onChange,
    acceptedObjects = _ref7.acceptedObjects,
    invalid = _ref7.invalid,
    helpText = _ref7.helpText,
    jsonLogicValues = _ref7.jsonLogicValues,
    layout = _ref7.layout;
  var _ref8 = jsonLogicValues || getJsonLogicValues({
      acceptedObjects: acceptedObjects,
      value: value
    }),
    attributeName = _ref8.attributeName,
    attributeSchema = _ref8.attributeSchema;
  return match(attributeSchema)["with"]({
    type: 'string',
    format: P.union('date', 'date-time')
  }, function () {
    assert('>' in value || '<' in value || '<=' in value || '>=' in value);
    var operator = firstPropertyKey(value);
    var operands = firstPropertyValue(value);
    var rightOperandValue = operands[1]["var"];
    return _jsxs(Flex, {
      gap: 2,
      direction: layout === 'wide' ? 'row' : 'column',
      basis: "100%",
      children: [_jsx(Box, {
        pt: layout === 'wide' ? 8 : 0,
        children: _jsxs(Select, {
          label: layout === 'wide' ? undefined : 'Operator',
          "aria-label": layout === 'wide' ? 'Operator' : undefined,
          value: operator,
          required: true,
          onChange: function onChange(newOperator) {
            if (newOperator === '') {
              return;
            }
            assert(newOperator === '<' || newOperator === '>' || newOperator === '<=' || newOperator === '>=');
            _onChange5(match(newOperator)["with"]('<', function (matched) {
              return _defineProperty({}, matched, operands);
            })["with"]('>', function (matched) {
              return _defineProperty({}, matched, operands);
            })["with"]('<=', function (matched) {
              return _defineProperty({}, matched, operands);
            })["with"]('>=', function (matched) {
              return _defineProperty({}, matched, operands);
            }).exhaustive());
          },
          appearance: "styled",
          emphasis: layout === 'wide' ? 'highlighted' : undefined,
          intent: layout === 'wide' ? 'primary' : undefined,
          children: [_jsx(Select.Option, {
            value: "<",
            label: "before"
          }), _jsx(Select.Option, {
            value: ">",
            label: "after"
          }), _jsx(Select.Option, {
            value: "<=",
            label: "before or equal to"
          }), _jsx(Select.Option, {
            value: ">=",
            label: "after or equal to"
          })]
        })
      }), _jsx(Flex.Item, {
        grow: layout === 'wide' ? 1 : undefined,
        children: _jsx(Select, {
          label: "Value",
          required: true,
          value: rightOperandValue,
          onChange: function onChange(newRightOperandValue) {
            var newOperands = [operands[0], {
              "var": newRightOperandValue
            }];
            _onChange5(match(operator)["with"]('<', function (matched) {
              return _defineProperty({}, matched, newOperands);
            })["with"]('>', function (matched) {
              return _defineProperty({}, matched, newOperands);
            })["with"]('<=', function (matched) {
              return _defineProperty({}, matched, newOperands);
            })["with"]('>=', function (matched) {
              return _defineProperty({}, matched, newOperands);
            }).exhaustive());
          },
          appearance: "styled",
          invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[value]')),
          helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[value]') ? helpText.replace('[value]', '') : '',
          children: getDateAttributes(acceptedObjects).filter(function (att) {
            return attributeName !== att.attributeKey;
          }).map(function (att) {
            return _jsx(Select.Option, {
              value: "".concat(att.objectKey, ".").concat(att.attributeKey),
              label: "".concat(att.objectTitle, " - ").concat(att.attributeTitle)
            }, "".concat(att.objectKey, ".").concat(att.attributeKey));
          })
        })
      })]
    });
  })["with"]({
    "enum": P.array()
  }, function () {
    return _jsx(EnumOperatorAndRightOperandInput, {
      acceptedObjects: acceptedObjects,
      onChange: _onChange5,
      value: value,
      helpText: helpText,
      invalid: invalid,
      layout: layout,
      jsonLogicValues: {
        objectName: (jsonLogicValues === null || jsonLogicValues === void 0 ? void 0 : jsonLogicValues.objectName) || '',
        objectSchema: jsonLogicValues === null || jsonLogicValues === void 0 ? void 0 : jsonLogicValues.objectSchema,
        attributeName: jsonLogicValues === null || jsonLogicValues === void 0 ? void 0 : jsonLogicValues.attributeName,
        attributeSchema: jsonLogicValues !== null && jsonLogicValues !== void 0 && jsonLogicValues.attributeSchema ? JsonSchemaProperty.parse(jsonLogicValues.attributeSchema) : undefined
      }
    });
  })["with"]({
    'x-type': P.union('program-id', 'school-group-id')
  }, function (schema) {
    assert(isMatching({
      "in": [{
        "var": P.string
      }, P.array(P.number)]
    }, value));
    var operands = firstPropertyValue(value);
    return _jsx(SearchableMultiCombobox, {
      entityType: schema['x-type'] === 'program-id' ? 'program' : 'school-group',
      label: "Values",
      value: operands[1],
      onChange: function onChange(newValues) {
        _onChange5({
          "in": [operands[0], newValues]
        });
      },
      invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[value]')),
      helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[value]') ? helpText.replace('[value] ', '') : ''
    });
  })["with"]({
    type: 'boolean'
  }, function () {
    assert(isMatching({
      '==': [{
        "var": P.string
      }, P["boolean"]]
    }, value));
    var operands = firstPropertyValue(value);
    return _jsx(RadioGroup, {
      label: "Value",
      value: operands[1].toString(),
      onChange: function onChange(newValue) {
        _onChange5({
          '==': [operands[0], newValue === 'true']
        });
      },
      children: _jsxs(Flex, {
        gap: layout === 'wide' ? 4 : 2,
        basis: "100%",
        direction: layout === 'wide' ? 'row' : 'column',
        children: [_jsx(RadioGroup.Option, {
          label: "True",
          value: "true"
        }), _jsx(RadioGroup.Option, {
          label: "False",
          value: "false"
        })]
      })
    });
  })["with"]({
    type: 'array',
    items: {
      type: 'string'
    }
  }, function (schema) {
    assert(isMatching({
      "in": [P.string, {
        "var": P.string
      }]
    }, value));
    return _jsx(StringEnumArrayOperatorAndLeftOperandInput, {
      onChange: _onChange5,
      value: value,
      helpText: helpText,
      invalid: invalid,
      layout: layout,
      schema: schema
    });
  })["with"](P.nullish, function () {
    return null;
  }).exhaustive();
}

/**
 * This input allows the user to build the right-hand-side of the jsonlogic
 * expression for 'array' type properties.
 *
 * @note The UI currently only supports a single 'array' type property
 * called 'tags', using a particular set of JsonLogic rules. This UI supports that
 * JsonLogic, and will probably not support other uses of the 'array' type.
 */
function StringEnumArrayOperatorAndLeftOperandInput(_ref17) {
  var value = _ref17.value,
    _onChange6 = _ref17.onChange,
    layout = _ref17.layout,
    invalid = _ref17.invalid,
    helpText = _ref17.helpText,
    schema = _ref17.schema;
  return _jsxs(Flex, {
    gap: 2,
    direction: layout === 'wide' ? 'row' : 'column',
    basis: "100%",
    children: [_jsx(Box, {
      pt: layout === 'wide' ? 8 : 0,
      children: _jsx(Select, {
        label: layout === 'wide' ? undefined : 'Operator',
        "aria-label": layout === 'wide' ? 'Operator' : undefined,
        value: "includes",
        onChange: function onChange() {},
        required: true,
        appearance: "styled",
        emphasis: layout === 'wide' ? 'highlighted' : undefined,
        intent: layout === 'wide' ? 'primary' : undefined,
        children: _jsx(Select.Option, {
          value: "includes",
          label: "includes"
        })
      })
    }), _jsx(Flex.Item, {
      grow: layout === 'wide' ? 1 : undefined,
      children: _jsx(Select, {
        label: "Value",
        required: true,
        value: value["in"][0],
        onChange: function onChange(newLeftOperandValue) {
          _onChange6({
            "in": [newLeftOperandValue, value["in"][1]]
          });
        },
        appearance: "styled",
        invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[value]')),
        helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[value]') ? helpText.replace('[value]', '') : '',
        children: getEnumOptions(schema.items).map(function (option) {
          return _jsx(Select.Option, {
            value: option.value,
            label: option.label
          }, option.value);
        })
      })
    })]
  });
}

/**
 * This input allows the user to build the right-hand-side of the jsonlogic
 * expression for 'string' type properties with enums
 */
function EnumOperatorAndRightOperandInput(_ref18) {
  var value = _ref18.value,
    _onChange7 = _ref18.onChange,
    invalid = _ref18.invalid,
    helpText = _ref18.helpText,
    jsonLogicValues = _ref18.jsonLogicValues,
    layout = _ref18.layout;
  var attributeSchema = jsonLogicValues.attributeSchema;
  assert(isMatching({
    "enum": P.array()
  }, attributeSchema));
  var parsedValue = JsonLogicEnumOperations.parse(value);
  var operator = firstPropertyKey(parsedValue);
  assert(operator === 'in' || operator === '==' || operator === '!=');
  var operands = firstPropertyValue(parsedValue);
  return _jsxs(Flex, {
    gap: 2,
    direction: layout === 'wide' ? 'row' : 'column',
    basis: "100%",
    children: [_jsx(Box, {
      pt: layout === 'wide' ? 8 : 0,
      children: _jsxs(Select, {
        label: layout === 'wide' ? undefined : 'Operator',
        "aria-label": layout === 'wide' ? 'Operator' : undefined,
        value: operator,
        required: true,
        onChange: function onChange(newOperator) {
          if (newOperator === '') {
            return;
          }
          assert(newOperator === '==' || newOperator === '!=' || newOperator === 'in');
          _onChange7(match(newOperator)["with"]('==', function () {
            return {
              '==': [operands[0], typeof operands[1] === 'string' ? operands[1] : '']
            };
          })["with"]('!=', function () {
            return {
              '!=': [operands[0], typeof operands[1] === 'string' ? operands[1] : '']
            };
          })["with"]('in', function () {
            return {
              "in": [operands[0], ['']]
            };
          }).exhaustive());
        },
        appearance: "styled",
        emphasis: layout === 'wide' ? 'highlighted' : undefined,
        intent: layout === 'wide' ? 'primary' : undefined,
        children: [_jsx(Select.Option, {
          value: "==",
          label: "equal to"
        }), _jsx(Select.Option, {
          value: "!=",
          label: "not equal to"
        }), _jsx(Select.Option, {
          value: "in",
          label: "in"
        })]
      })
    }), _jsx(Flex.Item, {
      grow: layout === 'wide' ? 1 : undefined,
      children: match(parsedValue)["with"]({
        "in": P.array()
      }, function () {
        assert(isMatching({
          "in": [{
            "var": P.string
          }, P.array(P.string)]
        }, parsedValue));
        var operands = firstPropertyValue(parsedValue);
        return _jsx(MultiCombobox, {
          label: "Values",
          value: operands[1],
          required: true,
          onChange: function onChange(newValues) {
            _onChange7({
              "in": [operands[0], newValues]
            });
          },
          invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[value]')),
          helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[value]') ? helpText.replace('[value] ', '') : '',
          multiline: true,
          children: getEnumOptions(attributeSchema).map(function (option) {
            return _jsx(MultiCombobox.Option, {
              value: option.value,
              label: option.label
            }, option.value);
          })
        });
      })["with"]({
        '==': P.array()
      }, {
        '!=': P.array()
      }, function (matching) {
        var operator = firstPropertyKey(matching);
        assert(operator === '==' || operator === '!=');
        assert(isMatching(_defineProperty({}, operator, [{
          "var": P.string
        }, P.string]), parsedValue));
        var operands = firstPropertyValue(parsedValue);
        return _jsx(Combobox, {
          label: "Value",
          size: "md",
          value: operands[1],
          required: true,
          onChange: function onChange(newValues) {
            _onChange7(operator === '==' ? {
              '==': [operands[0], newValues]
            } : {
              '!=': [operands[0], newValues]
            });
          },
          invalid: invalid && (helpText === null || helpText === void 0 ? void 0 : helpText.startsWith('[value]')),
          helpText: helpText !== null && helpText !== void 0 && helpText.startsWith('[value]') ? helpText.replace('[value] ', '') : '',
          children: getEnumOptions(attributeSchema).map(function (option) {
            return _jsx(Combobox.Option, {
              value: option.value,
              label: option.label
            }, option.value);
          })
        });
      }).exhaustive()
    })]
  });
}
function SearchableMultiCombobox(_ref19) {
  var entityType = _ref19.entityType,
    label = _ref19.label,
    value = _ref19.value,
    _onChange8 = _ref19.onChange,
    invalid = _ref19.invalid,
    helpText = _ref19.helpText;
  var _usePrefetchEntities = usePrefetchEntities(),
    prefetchEntities = _usePrefetchEntities.prefetchEntities;
  var _useDebouncedState = useDebouncedState(''),
    _useDebouncedState2 = _slicedToArray(_useDebouncedState, 3),
    debouncedSearchText = _useDebouncedState2[1],
    setSearchText = _useDebouncedState2[2];
  var _useEntities = useEntities({
      type: entityType,
      searchText: debouncedSearchText,
      entityIds: value
    }),
    data = _useEntities.data,
    error = _useEntities.error;
  var options = getComboboxOptions({
    entities: data,
    value: value
  });
  return _jsx(MultiCombobox, {
    onSearch: function onSearch(text) {
      // onSearch is called with some weird shit, so this is an attempt to
      // make the experience less jarring to the user
      if (!text.startsWith('[')) {
        setSearchText(text);
      }
    },
    value: value.map(function (item) {
      return item.toString();
    }),
    onChange: function onChange(newValue) {
      _onChange8(newValue.map(function (item) {
        return Number(item);
      }));
    },
    onPaste: ( /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(pasteEvent) {
        var parsedValue, entities;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pasteEvent.preventDefault();
              parsedValue = getArrayFromCommaDelimitedString(pasteEvent.text);
              _context.next = 4;
              return prefetchEntities({
                type: entityType,
                searchText: debouncedSearchText,
                entityIds: parsedValue.map(function (item) {
                  return Number(item);
                })
              });
            case 4:
              entities = _context.sent;
              _onChange8(parsedValue.filter(function (value) {
                return entities.some(function (entity) {
                  return entity.id === value;
                });
              }).map(function (value) {
                return Number(value);
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref20.apply(this, arguments);
      };
    }()),
    label: label,
    filterOption: function filterOption(option, searchText) {
      return option.label.toLowerCase().includes(searchText.toLowerCase());
    },
    invalid: !!error || invalid,
    helpText: error ? 'An error occurred while searching for options' : helpText,
    children: options.map(function (option) {
      return _jsx(MultiCombobox.Option, {
        label: option.label,
        value: option.value
      }, option.value);
    })
  }, entityType);
}
function getComboboxOptions(_ref21) {
  var _ref21$entities = _ref21.entities,
    entities = _ref21$entities === void 0 ? [] : _ref21$entities,
    value = _ref21.value;
  var existingIds = new Set(entities.map(function (item) {
    return item.id;
  }));
  var options = entities.map(function (dataItem) {
    return {
      value: dataItem.id,
      label: "[".concat(dataItem.id, "] ").concat(dataItem.name)
    };
  });
  var _iterator = _createForOfIteratorHelper(value),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var id = _step.value;
      if (existingIds.has(id.toString())) {
        continue;
      }
      options.push({
        value: id.toString(),
        label: "[".concat(id, "]")
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return sortBy(options, function (option) {
    return Number(option.value);
  });
}
function getJsonLogicValues(_ref22) {
  var acceptedObjects = _ref22.acceptedObjects,
    value = _ref22.value;
  return match(value)["with"]({
    "in": [P.string, {
      "var": P.string
    }]
  }, function (matched) {
    var objectName = matched["in"][1]["var"].split('.')[0] || '';
    var objectSchema = acceptedObjects[objectName];
    assert(!objectSchema || (objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.type) === 'object');
    var attributeName = matched["in"][1]["var"].split('.')[1] || '';
    var attributeSchema = objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.properties[attributeName];
    return {
      objectName: objectName,
      objectSchema: objectSchema,
      attributeName: attributeName,
      attributeSchema: attributeSchema
    };
  })["with"](P.union({
    "in": [{
      "var": P.string
    }, P.array()]
  }, {
    '<': P.array()
  }, {
    '>': P.array()
  }, {
    '<=': P.array()
  }, {
    '>=': P.array()
  }, {
    '==': P.array()
  }, {
    '!=': P.array()
  }), function (matched) {
    var operands = firstPropertyValue(matched);
    var objectName = operands[0]["var"].split('.')[0] || '';
    var objectSchema = acceptedObjects[objectName];
    assert(!objectSchema || (objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.type) === 'object');
    var attributeName = operands[0]["var"].split('.')[1] || '';
    var attributeSchema = objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.properties[attributeName];
    return {
      objectName: objectName,
      objectSchema: objectSchema,
      attributeName: attributeName,
      attributeSchema: attributeSchema
    };
  })["with"]({
    '!': {
      "var": P.string
    }
  }, function (matched) {
    var operands = firstPropertyValue(matched);
    var objectName = operands["var"].split('.')[0] || '';
    var objectSchema = acceptedObjects[objectName];
    return {
      objectName: objectName,
      objectSchema: objectSchema,
      attributeName: undefined,
      attributeSchema: undefined
    };
  })["with"]({
    none: P.array()
  }, function (matched) {
    var objectName = 'filter' in matched.none[0] ? matched.none[0].filter[0]["var"] : matched.none[0]["var"];
    var objectSchema = acceptedObjects[objectName];
    assert(!objectSchema || (objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.type) === 'array');
    return {
      objectName: objectName,
      objectSchema: objectSchema,
      attributeName: undefined,
      attributeSchema: undefined
    };
  })["with"]({
    some: P.array()
  }, function (matched) {
    var objectName = 'filter' in matched.some[0] ? matched.some[0].filter[0]["var"] : matched.some[0]["var"];
    var objectSchema = acceptedObjects[objectName];
    assert(!objectSchema || (objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.type) === 'array');
    return {
      objectName: objectName,
      objectSchema: objectSchema,
      attributeName: undefined,
      attributeSchema: undefined
    };
  }).exhaustive();
}

/**
 * Returns information about the values of a JsonLogic array, similar to
 * getJsonLogicValues. Array operations like 'some' and 'none' have some
 * unique complexity with multiple nested oeprations/pieces of JsonLogic
 */
function getJsonLogicArrayValues(_ref23) {
  var acceptedObjects = _ref23.acceptedObjects,
    value = _ref23.value;
  var _match$with$with$exha = match(value)["with"]({
      some: P.array()
    }, function (matched) {
      var arrayName = 'filter' in matched.some[0] ? matched.some[0].filter[0]["var"] : matched.some[0]["var"];
      var evaluationObjectName = getJsonLogicArrayEvaluationValues(matched.some[1]);
      var evaluationValue = matched.some[1];
      return {
        arrayName: arrayName,
        evaluationObjectName: evaluationObjectName,
        evaluationValue: evaluationValue
      };
    })["with"]({
      none: P.array()
    }, function (matched) {
      var arrayName = 'filter' in matched.none[0] ? matched.none[0].filter[0]["var"] : matched.none[0]["var"];
      var evaluationObjectName = getJsonLogicArrayEvaluationValues(matched.none[1]['!'][0]);
      var evaluationValue = matched.none[1]['!'][0];
      return {
        arrayName: arrayName,
        evaluationObjectName: evaluationObjectName,
        evaluationValue: evaluationValue
      };
    }).exhaustive(),
    arrayName = _match$with$with$exha.arrayName,
    evaluationObjectName = _match$with$with$exha.evaluationObjectName,
    evaluationValue = _match$with$with$exha.evaluationValue;
  var arraySchema = acceptedObjects[arrayName];
  assert(arraySchema.type === 'array');
  var evaluationObjectSchema = arraySchema.items.properties[evaluationObjectName];
  return {
    arrayName: arrayName,
    arraySchema: arraySchema,
    evaluationObjectName: evaluationObjectName,
    evaluationObjectSchema: evaluationObjectSchema,
    evaluationValue: evaluationValue
  };
}
function getJsonLogicArrayEvaluationValues(value) {
  return match(value)["with"]({
    '==': P.array()
  }, function (matchedValue) {
    return matchedValue['=='][0]["var"];
  })["with"]({
    '!=': P.array()
  }, function (matchedValue) {
    return matchedValue['!='][0]["var"];
  })["with"]({
    "in": [P.string, {
      "var": P.string
    }]
  }, function (matchedValue) {
    return matchedValue["in"][1]["var"];
  })["with"]({
    "in": [{
      "var": P.string
    }, P.array()]
  }, function (matchedValue) {
    return matchedValue["in"][0]["var"];
  })["with"]({
    '>': P.array()
  }, function (matchedValue) {
    return matchedValue['>'][0]["var"];
  })["with"]({
    '<': P.array()
  }, function (matchedValue) {
    return matchedValue['<'][0]["var"];
  })["with"]({
    '<=': P.array()
  }, function (matchedValue) {
    return matchedValue['<='][0]["var"];
  })["with"]({
    '>=': P.array()
  }, function (matchedValue) {
    return matchedValue['>='][0]["var"];
  })["with"]({
    '!': {
      "var": P.string
    }
  }, function (matchedValue) {
    return matchedValue['!']["var"];
  }).exhaustive();
}

/**
 * Validates that the value of a JsonLogicInput field is fully filled out
 *
 * @note Since JsonLogicInput has many "sub-inputs" it makes the validation a
 * bit more complex.  The approach we use is to "prefix" the error message with
 * a string that indicates which part of the input is invalid.  This way we can
 * display the error message in the correct place in the UI.
 */
export function validateJsonLogicFieldValue(value) {
  var result = JsonLogic.safeParse(value);
  if (!result.success) {
    return 'The value is not JsonLogic compliant';
  }
  return match(result.data)["with"]({
    "in": [{
      "var": P.string
    }, P.array()]
  }, function (logic) {
    if (logic["in"][0]["var"] === '') {
      return '[object] Object name is required';
    }
    if (logic["in"][0]["var"].split('.').length === 1) {
      return '[attribute] Attribute name is required';
    }
    if (logic["in"][1].length === 0) {
      return '[value] At-least one value is required';
    }
    return true;
  })["with"]({
    "in": [P.string, {
      "var": P.string
    }]
  }, function () {
    //TODO: Add validation for includes
    return true;
  })["with"](P.union({
    '<': P.array()
  }, {
    '>': P.array()
  }, {
    '<=': P.array()
  }, {
    '>=': P.array()
  }), function (logic) {
    var operands = firstPropertyValue(logic);
    if (operands[0]["var"] === '') {
      return '[object] Object name is required';
    }
    if (operands[0]["var"].split('.').length === 1) {
      return '[attribute] Attribute name is required';
    }
    if (operands[1]["var"] === '') {
      return '[value] Value is required';
    }
    return true;
  })["with"]({
    '==': P.array()
  }, function (logic) {
    if (logic['=='][0]["var"] === '') {
      return '[object] Object name is required';
    }
    if (logic['=='][0]["var"].split('.').length === 1) {
      return '[attribute] Attribute name is required';
    }
    return true;
  })["with"]({
    '!=': P.array()
  }, function () {
    //TODO: Add validation for !=

    return true;
  })["with"]({
    some: P.array()
  }, function () {
    //TODO: Add validation for some

    return true;
  })["with"]({
    none: P.array()
  }, function () {
    //TODO: Add validation for none/!

    return true;
  })["with"]({
    '!': {
      "var": P.string
    }
  }, function () {
    //TODO: Add validation for !
    return true;
  }).exhaustive();
}
function getDateAttributes(acceptedObjects) {
  var dateAttributes = [];
  for (var _i = 0, _Object$entries = Object.entries(acceptedObjects); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      objectKey = _Object$entries$_i[0],
      objectValue = _Object$entries$_i[1];
    if (objectValue.type === 'object') {
      for (var _i2 = 0, _Object$entries2 = Object.entries(objectValue.properties); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          attributeKey = _Object$entries2$_i[0],
          attributeValue = _Object$entries2$_i[1];
        if ('format' in attributeValue && (attributeValue.format === 'date' || attributeValue.format === 'date-time')) {
          dateAttributes.push({
            objectKey: objectKey,
            attributeKey: attributeKey,
            objectTitle: objectValue.title,
            attributeTitle: attributeValue.title
          });
        }
      }
    }
  }
  return dateAttributes;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function firstPropertyValue(obj) {
  return obj[Object.keys(obj)[0]];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function firstPropertyKey(obj) {
  // @ts-expect-error TS is technically correct but in practice this will be fine
  return Object.keys(obj)[0];
}

/** Converts a comma delimited string to an array.
 * Ignores empty commas and trims out whitespace  */
function getArrayFromCommaDelimitedString(value) {
  return value.split(/\s*,\s*(?:,\s*)*/);
}